import { IconLayer } from '@deck.gl/layers';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GOOGLE } from '@rsos/maps/constants/mapProviders';
import { panMapTo } from '@rsos/utils/panMapToCoordinate';
import usePrevious from '@rsos/utils/usePrevious';
import spriteMapping from '../assets/gis-search/sprites-output/sprites-info.json';
import gisSearchSprite from '../assets/gis-search/sprites-output/sprites_2x.png';
import layers from './storeLayers';

const useGisSearchGL = ({ map, overlay, isMapIconDisabled }) => {
  const mapProvider = useSelector(state => state.sinatra.ui.mapProvider);

  const selectedLocation = useSelector(
    state => state.gisSearch.selectedLocation,
  );

  const prevSelectedLocation = usePrevious(selectedLocation);

  const LAYER_IDS = {
    GIS_SEARCH_DEFAULT: 'gis-search-default',
  };

  const MARKER_SIZES = {
    sizeScale: 130, // this is the factor to scale the icon.
    sizeMinPixels: 30, // when zoomed out, the max height of the icon.
    sizeMaxPixels: 45, // when zoomed in, the max height of the icon.
  };

  const layerFactories = {
    [LAYER_IDS.GIS_SEARCH_DEFAULT]: (data, extraProps = {}) => {
      return new IconLayer({
        id: LAYER_IDS.GIS_SEARCH_DEFAULT,
        data,
        getPosition: d => [d.location.x, d.location.y],
        pickable: !isMapIconDisabled,
        autoHighlight: true,
        highlightColor: [255, 255, 255, 60],
        iconAtlas: gisSearchSprite,
        iconMapping: spriteMapping,
        sizeUnits: 'meters',
        ...MARKER_SIZES,
        getIcon: () => 'gis_search', // matches entry in iconMapping
        onHover: () => {
          // do nothing
        },

        onClick: () => {
          // do nothing
        },

        ...extraProps,
      });
    },
  };
  useEffect(() => {
    if (overlay && selectedLocation) {
      layers.save(
        layerFactories[LAYER_IDS.GIS_SEARCH_DEFAULT]([selectedLocation], {
          visible: true,
        }),
      );
      overlay.setLayers(layers.getAll());
      const viewOption = {
        center: [selectedLocation.location.x, selectedLocation.location.y],
      };
      if (!prevSelectedLocation && selectedLocation) {
        panMapTo({
          mapProvider,
          mapInstance: map.mapInstance,
          latitude: viewOption.center[1],
          longitude: viewOption.center[0],
          zoom: mapProvider === GOOGLE ? 16 : 18,
        });
      }
    } else if (overlay && !selectedLocation && prevSelectedLocation) {
      layers.save(
        layerFactories[LAYER_IDS.GIS_SEARCH_DEFAULT]([prevSelectedLocation], {
          visible: false,
        }),
      );
      overlay.setLayers(layers.getAll());
      /*
        current implementation has requirement to not change viewport when marker is removed
        add useCenterPoint and uncomment below code to recenter to jurisdiction/call's center when marker is removed
        const center = useCenterPoint();
        map.mapInstance.view.goTo({
          center: [center.longitude, center.latitude],
        });
      */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overlay, selectedLocation, isMapIconDisabled]);
};

export const GisSearchGL = React.memo(({ map, overlay, isMapIconDisabled }) => {
  useGisSearchGL({ map, overlay, isMapIconDisabled });
  return <></>;
});
